import { DELIVERY_FEE_SKU, PACKAGE_WRAPPING_FEE_SKU } from '@/utils/constants';

const exceptionalProductSkus = [
  DELIVERY_FEE_SKU,
  PACKAGE_WRAPPING_FEE_SKU,
];

function refineOrderedProducts(products, orderedProducts, promotionAppliedProducts) {
  const resultProducts = [];
  const exceptinalProducts = [];
  orderedProducts.forEach((n) => {
    const temp = products.find((m) => n.item_sku === m.item_sku);
    if (temp) {
      const bool = !!promotionAppliedProducts
        .find((nm) => nm === n.item_sku);
      if (exceptionalProductSkus.includes(n.item_sku)) {
        exceptinalProducts.push({
          item_name: temp.item_name,
          item_sku: temp.item_sku,
          img_url: temp.img_url,
          outlink: temp.outlink,
          price: n.price,
          dose_cnt: n.dose_cnt,
          total_price: n.total_price,
          promotionYN: false,
        });
      } else {
        resultProducts.push(
          {
            item_name: temp.item_name,
            item_sku: temp.item_sku,
            img_url: temp.img_url,
            outlink: temp.outlink,
            price: n.price,
            dose_cnt: n.dose_cnt,
            total_price: n.total_price,
            promotionYN: bool,
          },
        );
      }
    } else {
      console.warn(`${n.item_sku} is not found in product-list`);
    }
  });
  resultProducts.push(...exceptinalProducts);

  return resultProducts;
}

export default {
  refineOrderedProducts,
};



// WEBPACK FOOTER //
// ./src/utils/helpers/order.js